<div class="question-open-ended">
  <p class="question-text">{{ question.questionText }}</p>

  <textarea
    class="answer-input"
    rows="8"
    [attr.maxlength]="maxLength"
    [value]="responseText"
    (input)="onInput($any($event.target).value)"
    placeholder=""
  ></textarea>

  <div class="char-counter">{{ responseText.length }} / {{ maxLength }}</div>
</div>
